export const GET_SPRINT_BOOKING_LINK_DETAILS_DATA = "GET_SPRINT_BOOKING_LINK_DETAILS_DATA"
export const CLEAR_SPRINT_BOOKING_LINK_DETAILS_DATA = "CLEAR_SPRINT_BOOKING_LINK_DETAILS_DATA"